module.exports = __webpack_public_path__ + "img/view-list.df3d2b3c.svg";